import { useEffect, useRef } from "react";

/**
 * Polling inteligente:
 *  - Pausa cuando la tab no está visible (document.hidden)
 *  - Pausa cuando la red está offline
 *  - Refresca inmediatamente cuando vuelve a estar visible o vuelve la red
 *  - Default 60s — más amigable que 15-30s
 */
export function useSmartPoll(callback, intervalMs = 60_000) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    let timer = null;

    const run = async () => {
      try { await cbRef.current?.(); }
      catch (err) { console.warn("[useSmartPoll] callback error:", err?.message); }
    };
    const start = () => {
      if (timer) return;
      timer = setInterval(() => {
        if (!document.hidden && navigator.onLine !== false) run();
      }, intervalMs);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    start();

    const onVisible = () => {
      if (!document.hidden) {
        run();      // refresca al volver
        start();
      } else {
        stop();
      }
    };
    const onOnline = () => { run(); start(); };
    const onOffline = () => stop();

    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);

    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, [intervalMs]);
}
